export default {
    API_ENDPOINT: 'https://calm-ravine-98268.herokuapp.com'
}